import { useEffect } from 'react';

export const SITE_URL = 'https://partners.outfino.app';

function upsert(selector, create, attr, value) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = create();
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
}

function setMeta(attr, key, content) {
  upsert(
    `meta[${attr}="${key}"]`,
    () => {
      const el = document.createElement('meta');
      el.setAttribute(attr, key);
      return el;
    },
    'content',
    content,
  );
}

export default function useSeo({ title, description, path, lang }) {
  useEffect(() => {
    const url = `${SITE_URL}${path}`;
    document.title = title;
    if (lang) document.documentElement.lang = lang;
    setMeta('name', 'description', description);
    setMeta('property', 'og:title', title);
    setMeta('property', 'og:description', description);
    setMeta('property', 'og:url', url);
    setMeta('name', 'twitter:title', title);
    setMeta('name', 'twitter:description', description);
    upsert(
      'link[rel="canonical"]',
      () => {
        const el = document.createElement('link');
        el.setAttribute('rel', 'canonical');
        return el;
      },
      'href',
      url,
    );
  }, [title, description, path, lang]);
}
